import httpWrapper from '../HttpWrapper'
import { AddCandidateToRoleReq } from './models/addCandidateToRole/AddCandidateToRoleReq'
import { AddCompanyLinksReq } from './models/addCompanyLinks/AddCompanyLinksReq'
import { CreateRoleReq } from './models/createRole/CreateRoleReq'
import { CreateRoleRes } from './models/createRole/CreateRoleRes'
import { CreateRoleViaLlmReq } from './models/createRoleViaLlm/CreateRoleViaLlmReq'
import { CreateRoleViaLlmRes } from './models/createRoleViaLlm/CreateRoleViaLlmRes'
import { DeleteCompanyLinksReq } from './models/deleteCompanyLinks/DeleteCompanyLinksReq'
import { GetAllRes } from './models/getAll/GetAllRolesRes'
import { GetAllRolesLiteReq } from './models/getAllLite/GetAllRolesLiteReq'
import { GetAllRolesLiteRes } from './models/getAllLite/GetAllRolesLiteRes'
import { GetCandidateReq } from './models/getCandidate/GetCandidateReq'
import { GetCandidateRes } from './models/getCandidate/GetCandidateRes'
import { GetCandidateCountForRole } from './models/getCandidateCountForRole/GetCandidateCountForRoleReq'
import { GetCandidatesReq } from './models/getCandidates/GetCandidatesReq'
import { GetCandidatesRes } from './models/getCandidates/GetCandidatesRes'
import { GetJobRelevancyCandidatesReq } from './models/getJobRelevancyCandidates/GetJobRelevancyCandidatesReq'
import { GetJobRelevancyCandidatesRes } from './models/getJobRelevancyCandidates/GetJobRelevancyCandidatesRes'
import { GetRoleLiteReq } from './models/getLite/GetRoleLiteReq'
import { GetRoleLiteRes } from './models/getLite/GetRoleLiteRes'
import { GetSharedWithUsersForRoleReq } from './models/getSharedWithUsersForRole/GetSharedWithUsersForRoleReq'
import { GetSharedWithUsersForRoleRes } from './models/getSharedWithUsersForRole/GetSharedWithUsersForRoleRes'
import { GetCandidateReviewStatusReq } from './models/getCandidateReviewStatus/GetCandidateReviewStatusReq'
import { GetCandidateReviewStatusRes } from './models/getCandidateReviewStatus/GetCandidateReviewStatusRes'
import { UpdateCandidateReviewStatusReq } from './models/updateCandidateReviewStatus/UpdateCandidateReviewStatusReq'
import { GetOrStartCandidateReviewSearchReq } from './models/getOrStartCandidateReviewSearch/GetOrStartCandidateReviewSearchReq'
import { GetOrStartCandidateReviewSearchRes } from './models/getOrStartCandidateReviewSearch/GetOrStartCandidateReviewSearchRes'
import { GetCandidateReviewResultsReq } from './models/getCandidateReviewResults/GetCandidateReviewResultsReq'
import { GetCandidateReviewResultsRes } from './models/getCandidateReviewResults/GetCandidateReviewResultsRes'
import { GetCandidateEvaluationsReq } from './models/getCandidateEvaluations/GetCandidateEvaluationsReq'
import { GetCandidateEvaluationsRes } from './models/getCandidateEvaluations/GetCandidateEvaluationsRes'
import { CandidateReviewActionReq } from './models/candidateReviewAction/CandidateReviewActionReq'
import { RemoveCandidateFromRoleReq } from './models/removeCandidateFromRole/RemoveCandidateFromRoleReq'
import { SaveHiringManagerFeedbackForCandidateReq } from './models/saveHiringManagerFeedback/SaveHiringManagerFeedbackReq'
import { SearchCandidatesRes } from './models/searchCandidates/SearchCandidatesRes'
import { SearchOnJobRelevancyRes } from './models/searchOnJobRelevancy/SearchOnJobRelevancyRes'
import { SendInviteToNewUsersReq } from './models/sendInviteToNewUsers/SendInviteToNewUsersReq'
import { SetCandidateContactedValueReq } from './models/setCandidateContactedValue/SetCandidateContactedValueReq'
import { SetCandidateInterestedValueReq } from './models/setCandidateInterestedValue/SetCandidateInterestedValueReq'
import { SetCandidatesPresentValueReq } from './models/setCandidatePresentValue/SetCandidatesPresentValueReq'
import { ShareRoleWithUsersReq } from './models/shareRoleWithUsers/ShareRoleWithUsersReq'
import { UpdateRoleReq } from './models/updateRole/UpdateRoleReq'
import { AddNetworkLinksReq } from './models/addNetworkLinks/AddNetworkLinksReq'
import { DeleteNetworkLinksReq } from './models/deleteNetworkLinks/DeleteNetworkLinksReq'
import {
    GetSharedWithUsersWithStatusReq,
    GetSharedWithUsersWithStatusRes,
} from './models/getSharedWithUsersWithStatus/GetSharedWithUsersWithStatus'
import {
    GetRecommendedCandidatesForRoleReq,
    GetRecommendedCandidatesForRoleRes,
} from './models/getRecommendedCandidatesForRole/GetRecommendedCandidatesForRole'
import { ShareRoleWithUsersRes } from './models/shareRoleWithUsers/ShareRoleWithUsersRes'

class RoleApi {
    private static instance: RoleApi

    public constructor() {
        if (RoleApi.instance) {
            return RoleApi.instance
        }

        RoleApi.instance = this
    }

    public async getAll(): Promise<GetAllRes> {
        return await httpWrapper.get('/role/all')
    }

    // public async get(data: GetRoleReq): Promise<GetRes> {
    //     const queryParams = new URLSearchParams({
    //         roleId: data.roleId,
    //     })

    //     if (data.hiringManagerId) {
    //         queryParams.append('hiringManagerId', data.hiringManagerId)
    //     }

    //     if (data.returnExcludedCandidates) {
    //         queryParams.append(
    //             'returnExcludedCandidates',
    //             data.returnExcludedCandidates.toString(),
    //         )
    //     }

    //     queryParams.append('rankingModel', data.rankingModel)

    //     return await httpWrapper.get(`/role`, queryParams)
    // }

    public async getLite(data: GetRoleLiteReq): Promise<GetRoleLiteRes> {
        const queryParams = new URLSearchParams({
            roleId: data.roleId,
        })

        if (data.includeHiringTeamIds !== undefined) {
            queryParams.append(
                'includeHiringTeamIds',
                data.includeHiringTeamIds.toString(),
            )
        }

        if (data.includeSharedWithUserIds !== undefined) {
            queryParams.append(
                'includeSharedWithUserIds',
                data.includeSharedWithUserIds.toString(),
            )
        }

        if (data.includeNetworkLinkIds !== undefined) {
            queryParams.append(
                'includeNetworkLinkIds',
                data.includeNetworkLinkIds.toString(),
            )
        }

        if (data.includeCompanyLinkIds !== undefined) {
            queryParams.append(
                'includeCompanyLinkIds',
                data.includeCompanyLinkIds.toString(),
            )
        }

        return await httpWrapper.get(`/role/lite`, queryParams)
    }

    public async getAllLite(
        data: GetAllRolesLiteReq,
    ): Promise<GetAllRolesLiteRes> {
        const queryParams = new URLSearchParams()

        if (data.includeHiringTeamIds !== undefined) {
            queryParams.append(
                'includeHiringTeamIds',
                data.includeHiringTeamIds.toString(),
            )
        }

        if (data.includeSharedWithUserIds !== undefined) {
            queryParams.append(
                'includeSharedWithUserIds',
                data.includeSharedWithUserIds.toString(),
            )
        }

        if (data.includeNetworkLinkIds !== undefined) {
            queryParams.append(
                'includeNetworkLinkIds',
                data.includeNetworkLinkIds.toString(),
            )
        }

        if (data.includeCompanyLinkIds !== undefined) {
            queryParams.append(
                'includeCompanyLinkIds',
                data.includeCompanyLinkIds.toString(),
            )
        }

        return await httpWrapper.get(`/role/all-lite`, queryParams)
    }

    public async setCandidatesPresentValue(
        data: SetCandidatesPresentValueReq,
    ): Promise<void> {
        return await httpWrapper.post(
            '/role/set-candidates-present-value',
            data,
        )
    }

    public async setCandidateContactedValue(
        data: SetCandidateContactedValueReq,
    ): Promise<void> {
        return await httpWrapper.post(
            '/role/set-candidate-contacted-value',
            data,
        )
    }

    public async setCandidateInterestedValue(
        data: SetCandidateInterestedValueReq,
    ): Promise<void> {
        return await httpWrapper.post(
            '/role/set-candidate-interested-value',
            data,
        )
    }

    public async addCompanyLinks(data: AddCompanyLinksReq): Promise<void> {
        return await httpWrapper.post('/role/add-company-links', data)
    }

    public async deleteCompanyLinks(
        data: DeleteCompanyLinksReq,
    ): Promise<void> {
        return await httpWrapper.post('/role/delete-company-links', data)
    }

    // public async saveHiringManagerFeedback(
    //     data: SaveHiringManagerFeedbackReq,
    // ): Promise<void> {
    //     return await httpWrapper.post(
    //         '/role/save-hiring-manager-feedback-for-candidate',
    //         data,
    //     )
    // }

    public async saveHiringManagerFeedbackForCandidate(
        data: SaveHiringManagerFeedbackForCandidateReq,
    ): Promise<void> {
        return await httpWrapper.post(
            '/role/save-hiring-manager-feedback-for-candidate',
            data,
        )
    }

    public async createRole(data: CreateRoleReq): Promise<CreateRoleRes> {
        return await httpWrapper.post('/role/create-role', data)
    }

    public async createRoleViaLlm(
        data: CreateRoleViaLlmReq,
    ): Promise<CreateRoleViaLlmRes> {
        return await httpWrapper.post('/role/create-role-via-llm', data)
    }

    public async updateRole(data: UpdateRoleReq): Promise<void> {
        await httpWrapper.post('/role/update-role', data)
    }

    public async getCandidates(
        data: GetCandidatesReq,
    ): Promise<GetCandidatesRes> {
        return await httpWrapper.post('/role/candidates-lite', data)
    }

    public async getCandidate(data: GetCandidateReq): Promise<GetCandidateRes> {
        return await httpWrapper.post('/role/candidate-lite', data)
    }

    public async getJobRelevancyCandidates(
        data: GetJobRelevancyCandidatesReq,
    ): Promise<GetJobRelevancyCandidatesRes> {
        return await httpWrapper.post(
            '/ranking/get-job-relevancy-candidates',
            data,
        )
    }

    public async exportCandidatesCsv(roleId: string): Promise<Blob> {
        const queryParams = new URLSearchParams()
        queryParams.append('roleId', roleId)

        return await httpWrapper.get<Blob>(
            `/role/export-candidates-csv`,
            queryParams,
            { responseType: 'blob' },
        )
    }

    public async searchCandidates(
        searchPhrases: string[],
    ): Promise<SearchCandidatesRes> {
        return await httpWrapper.post('/ranking/search-candidates', {
            searchPhrases,
        })
    }

    public async searchOnJobRelevancy(
        searchPhrases: string[],
        jobTitles: string[],
    ): Promise<SearchOnJobRelevancyRes> {
        return await httpWrapper.post('/ranking/search-on-job-relevancy', {
            searchPhrases,
            jobTitles,
        })
    }

    public async inviteCandidateToApply(
        roleId: string,
        candidateId: string,
    ): Promise<void> {
        return await httpWrapper.post('/role/invite-candidate-to-apply', {
            roleId,
            candidateId,
        })
    }

    public async bookInterview(
        roleId: string,
        candidateId: string,
        hmAvailableDateTimes: Date[],
    ): Promise<void> {
        return await httpWrapper.post('/role/book-interview', {
            roleId,
            candidateId,
            hmAvailableDateTimes,
        })
    }

    public async addCandidateToRole(
        data: AddCandidateToRoleReq,
    ): Promise<void> {
        return await httpWrapper.post('/role/add-candidate-to-role', data)
    }

    public async removeCandidateFromRole(
        data: RemoveCandidateFromRoleReq,
    ): Promise<void> {
        return await httpWrapper.post('/role/remove-candidate-from-role', data)
    }

    public async getCandidateCountForRole(
        data: GetCandidateCountForRole,
    ): Promise<number> {
        return await httpWrapper.post('/role/candidate-count', data)
    }

    public async getSharedWithUsersForRole(
        data: GetSharedWithUsersForRoleReq,
    ): Promise<GetSharedWithUsersForRoleRes> {
        return await httpWrapper.post('/role/get-shared-with-users', data)
    }

    public async shareRoleWithUsers(
        data: ShareRoleWithUsersReq,
    ): Promise<ShareRoleWithUsersRes> {
        return await httpWrapper.post('/role/share-role-with-users', data)
    }

    public async sendInviteToNewUsers(
        data: SendInviteToNewUsersReq,
    ): Promise<void> {
        return await httpWrapper.post('/role/send-invite-to-new-users', data)
    }

    public async getCandidateReviewStatus(
        data: GetCandidateReviewStatusReq,
    ): Promise<GetCandidateReviewStatusRes> {
        return await httpWrapper.post('/role/get-candidate-review-status', data)
    }

    public async updateCandidateReviewStatus(
        data: UpdateCandidateReviewStatusReq,
    ): Promise<void> {
        return await httpWrapper.post(
            '/role/update-candidate-review-status',
            data,
        )
    }

    public async getOrStartCandidateReviewSearch(
        data: GetOrStartCandidateReviewSearchReq,
    ): Promise<GetOrStartCandidateReviewSearchRes> {
        return await httpWrapper.post(
            '/role/get-or-start-candidate-review-search',
            data,
        )
    }

    public async getCandidateReviewResults(
        data: GetCandidateReviewResultsReq,
    ): Promise<GetCandidateReviewResultsRes> {
        return await httpWrapper.post(
            '/role/get-candidate-review-results',
            data,
        )
    }

    public async getCandidateEvaluations(
        data: GetCandidateEvaluationsReq,
    ): Promise<GetCandidateEvaluationsRes> {
        return await httpWrapper.post('/role/get-candidate-evaluations', data)
    }

    public async candidateReviewAction(
        data: CandidateReviewActionReq,
    ): Promise<void> {
        await httpWrapper.post('/role/candidate-review-action', data)
    }

    public async addNetworkLinks(data: AddNetworkLinksReq): Promise<void> {
        return await httpWrapper.post('/role/add-network-links', data)
    }

    public async deleteNetworkLinks(
        data: DeleteNetworkLinksReq,
    ): Promise<void> {
        return await httpWrapper.post('/role/delete-network-links', data)
    }

    public async getSharedWithUsersWithStatus(
        data: GetSharedWithUsersWithStatusReq,
    ): Promise<GetSharedWithUsersWithStatusRes> {
        return await httpWrapper.post(
            '/role/get-shared-with-users-with-status',
            data,
        )
    }

    public async getRecommendedCandidatesForRole(
        data: GetRecommendedCandidatesForRoleReq,
    ): Promise<GetRecommendedCandidatesForRoleRes> {
        return await httpWrapper.post('/role/get-recommended-candidates', data)
    }
}

const roleApi = new RoleApi()
export default roleApi
